import request from '../request'

// 获取分享简历 加密token
export const getCvEncodedToken = (cv_token, params) => {
	return request({
		url: `/v3/share_cvs/${cv_token}/encoded_token`,
		method: 'GET',
		params
	})
}

// 获取分享简历单人权限
export const getCvAuth = (cv_encoded_token, cv_account_token) => {
	return request({
		url: `/v3/share_cvs/${cv_encoded_token}/auths/${cv_account_token}`,
		method: 'GET',
		params: {}
	})
}
// 修改分享简历单人权限
export const putCvAuth = (cv_encoded_token, cv_account_token, data) => {
	return request({
		url: `/v3/share_cvs/${cv_encoded_token}/auths/${cv_account_token}`,
		method: 'PUT',
		data
	})
}

// 更新分享简历单人查看时间
export const addCvViewed = cv_encoded_token => {
	return request({
		url: `/v3/share_cvs/${cv_encoded_token}/viewed`,
		method: 'PUT',
		data: {}
	})
}


// 获取分享简历设置
export const getCvSettings = cv_encoded_token => {
	return request({
		url: `/v3/share_cvs/${cv_encoded_token}/settings`,
		method: 'GET',
		params: {}
	})
}

// 修改分享简历设置
export const putCvSettings = (cv_encoded_token, data) => {
	return request({
		url: `/v3/share_cvs/${cv_encoded_token}/settings`,
		method: 'PUT',
		data
	})
}

// 获取分享简历用户列表
export const getCvAuths = (cv_encoded_token, params) => {
	return request({
		url: `/v3/share_cvs/${ cv_encoded_token }/auths`,
		method: 'GET',
		params
	})
}

// 获取分享简历html
export const getCvHtml = (cv_encoded_token, params) => {
	return request({
		url: `/v3/share_cvs/${ cv_encoded_token }/html`,
		method: 'GET',
		params: params || {}
	})
}

// 获取owner 小红点查看时间
export const getOwnerTime = (cv_encoded_token, cv_account_token) => {
	return request({
		url: `/v3/share_cvs/${cv_encoded_token}/view/${cv_account_token}`,
		method: 'GET',
		params: {}
	})
}

// 修改owner 小红点查看时间
export const updateOwnerTime = (cv_encoded_token, cv_account_token) => {
	return request({
		url: `/v3/share_cvs/${cv_encoded_token}/view/${cv_account_token}`,
		method: 'PUT',
		data: {}
	})
}

// 获取分享简历详情
export const getShareCvs = (cv_encoded_token, params) => {
	return request({
		url: `/v3/share_cvs/${ cv_encoded_token }`,
		method: 'GET',
		params: params || {}
	})
}

// 获取分享评论详情
export const getCommentsInfo = (type,params) => {
	return request({
		url: `/v3/${type}/share`,
		method: 'GET',
		params: params
	})
}

// 获取 分享简历的个人信息
export const getProfileDataByShare = (cv_token) => {
  return request({
    url: `/v3/cvs/${cv_token}/profile/share`,
    method: 'get'
  })
}


export const getCustomInfoByShare = (id, params) => {
  return request({
    url: `/v3/custom_sections/${ id }/share`,
    method: 'get',
    params
  })
}

export const getExtrasInfoByShare = (params) => {
  return request({
    url: '/v3/extras/share',
    method: 'get',
    params
  })
}

export const getEduInfoByShare = (params) => {
  return request({
    url: '/v3/edus/share',
    method: 'get',
    params
  })
}

export const getOrgInfoByShare = (params) => {
  return request({
    url: '/v3/orgs/share',
    method: 'get',
    params
  })
}

export const getOpuInfoByShare = (params) => {
  return request({
    url: '/v3/opus/share',
    method: 'get',
    params
  })
}

export const getWorkInfoByShare = (params) => {
  return request({
    url: '/v3/works/share',
    method: 'get',
    params
  })
}
